export const getDomain =(url)=> {
    if (!url) {
      
      return;
    }

    url = url.replace(/(https?:\/\/)?(www.)?/i, "");

    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }

    return url;
  };

  export const getFormatedTime =(date)=> {
    date = new Date(date);

    return date.toLocaleTimeString();
  };
